
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
// Libs
import { ProfileActivityConfig } from '@/lib/analytics/pages/profileActivity';
import { ANALYZE_PERFORMANCE } from '@/lib/routes/privateRoutes';
// Hooks
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Components
import LoaderPage from '@/components/base/Loader/LoaderPage';
import LayoutAnalytics from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
const Page = () => {
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const router = useRouter();
    if (isTreeStructureActivated) {
        router.push(ANALYZE_PERFORMANCE);
        return <LoaderPage />;
    }
    return (<LayoutAnalytics config={ProfileActivityConfig} title="commons:menu.profile_activity" withCoreEventPendo/>);
};
const Activity = () => {
    return (<WrapperSwitchLayout>
            <Page />
        </WrapperSwitchLayout>);
};
export default Activity;

    async function __Next_Translate__getStaticProps__193b0d82398__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/analytics/activity',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__193b0d82398__ as getStaticProps }
  